export var MeetingHistoryActions;
(function (MeetingHistoryActions) {
    MeetingHistoryActions["GET_MEETING_HISTORY"] = "MEETING_HISTORY/GET_MEETING_HISTORY";
    MeetingHistoryActions["GET_MEETING_HISTORY_FOR_CSV"] = "MEETING_HISTORY/GET_MEETING_HISTORY_FOR_CSV";
    MeetingHistoryActions["SET_MEETING_HISTORY_IS_LOADING"] = "MEETING_HISTORY/IS_LOADING";
})(MeetingHistoryActions || (MeetingHistoryActions = {}));
